import React from "react";
import { useSelector } from "react-redux";
import { Form, Input, InputNumber } from "antd";
import Modal from "../Modal";
import { errorToast, successToast } from "../../../../helpers/toast";
import { createSkuRepricingRequest } from "../../../../services/sku";

const RequestRepricingModal = ({ closeModal, sku }) => {
  const [form] = Form.useForm();
  const selectedMechanic = useSelector((state) => state.mechanic);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  // Mock mechanics list - replace with actual API call

  const handleSubmit = async (values) => {
    setIsSubmitting(true);

    try {
      const requestData = {
        skuId: sku.id,
        suggestedPrice: Number(values.suggestedPrice),
        creatorNotes: values.creatorNotes,
      };

      // Add mechanicId from Redux state if it exists
      if (selectedMechanic?.id) {
        requestData.mechanicId = selectedMechanic.id;
      }

      await createSkuRepricingRequest(requestData);

      successToast("تم إرسال طلب إعادة التسعير بنجاح");
      setIsSubmitting(false);
      closeModal();
    } catch (error) {
      console.error(error);
      const errorMessage =
        error?.response?.data?.message || "حدث خطأ أثناء إرسال الطلب";
      errorToast(errorMessage);
      setIsSubmitting(false);
    }
  };

  return (
    <Modal close={closeModal} classNames="lg:w-1/2 sm:w-2/3">
      <div dir="rtl" className="w-full">
        <h3 className="text-xl font-bold text-center mb-4">طلب إعادة تسعير</h3>

        <div className="bg-gray-50 p-3 rounded-lg mb-4">
          <p className="text-sm">
            <span className="font-semibold"> ID:</span> {sku.id}
          </p>
          <p className="text-sm">
            <span className="font-semibold"> اسم المنتج:</span>{" "}
            {sku.commercialName}
          </p>
          {sku.inventoryPrice && (
            <p className="text-sm">
              <span className="font-semibold">السعر الحالي:</span>{" "}
              {sku.inventoryPrice} جم
            </p>
          )}
        </div>

        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <Form.Item
            name="suggestedPrice"
            label={
              <span className="font-medium">
                السعر المقترح <span className="text-red-500">*</span>
              </span>
            }
            rules={[
              {
                required: true,
                message: "من فضلك أدخل السعر المقترح بالارقام",
              },
              {
                type: "number",
                min: 0,
                message: "السعر يجب أن يكون أكبر من 0",
              },
            ]}
          >
            <InputNumber
              placeholder="أدخل السعر المقترح"
              style={{ width: "100%" }}
              step={0.01}
              min={0}
              className="w-full"
            />
          </Form.Item>

          <Form.Item
            name="creatorNotes"
            label={
              <span className="font-medium">
                ملاحظات <span className="text-red-500">*</span>
              </span>
            }
            rules={[
              { required: true, message: "من فضلك أضف الملاحظات" },
              { whitespace: true, message: "الملاحظات لا يمكن أن تكون فارغة" },
            ]}
          >
            <Input.TextArea
              rows={4}
              placeholder="أضف اسباب طلب إعادة التسعير"
            />
          </Form.Item>

          <div className="flex gap-3 mt-4">
            <button
              type="submit"
              disabled={isSubmitting}
              className="flex-1 bg-dark-blue text-white p-3 rounded-lg hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
            >
              {isSubmitting ? "جاري الإرسال..." : "إرسال الطلب"}
            </button>
            <button
              type="button"
              onClick={closeModal}
              className="flex-1 bg-gray-300 text-gray-700 p-3 rounded-lg hover:bg-gray-400 font-medium"
            >
              إلغاء
            </button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default RequestRepricingModal;
